/**
 * Normaliza un método de pago proveniente de la API remota (snake_case) a camelCase consistente.
 */
const normalizePaymentMethod = (paymentMethod) => ({
  id: paymentMethod.id,
  holderName: paymentMethod.holder_name || paymentMethod.holderName || '',
  brand: paymentMethod.brand || 'visa',
  last4: String(paymentMethod.last4 || '').slice(-4),
  expMonth: String(paymentMethod.exp_month || paymentMethod.expMonth || '').padStart(2, '0'),
  expYear: String(paymentMethod.exp_year || paymentMethod.expYear || ''),
  isDefault: Boolean(paymentMethod.is_default ?? paymentMethod.isDefault),
  provider: paymentMethod.provider || 'stripe',
  stripePaymentMethodId:
    paymentMethod.stripe_payment_method_id ||
    paymentMethod.stripePaymentMethodId ||
    paymentMethod.id ||
    null,
});

export default normalizePaymentMethod;
